<template>
    <div class="section-baner">
        <div class="baner-bg" :style="'background-image:url(' + options[0].bg + ')'"></div>
        <div class="baner-desc">
            <span>{{ options[0].title }}</span>
            <p>{{ options[0].desc }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'section-baner',
        props: ['options'],
        data () {
            return {
            }
        },
    }
</script>

<style lang="scss">
    @import '@/styles/components/partials/section-baner.scss';
    @import '@/styles/components/partials/respond/section-baner-respond.scss';
</style>